import { render, staticRenderFns } from "./serverSummaryData.vue?vue&type=template&id=a0327680&scoped=true&"
import script from "./serverSummaryData.vue?vue&type=script&lang=js&"
export * from "./serverSummaryData.vue?vue&type=script&lang=js&"
import style0 from "./serverSummaryData.vue?vue&type=style&index=0&id=a0327680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0327680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0327680')) {
      api.createRecord('a0327680', component.options)
    } else {
      api.reload('a0327680', component.options)
    }
    module.hot.accept("./serverSummaryData.vue?vue&type=template&id=a0327680&scoped=true&", function () {
      api.rerender('a0327680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/serverSummaryData.vue"
export default component.exports